export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: '659b4de1-40a7-4287-a96f-ac2075a63888'
  },
  config: {
    instance: 'https://login.microsoftonline.com/19647938-80b8-4366-a101-1e038f5ae7dc',
    tenant: '19647938-80b8-4366-a101-1e038f5ae7dc',
    clientId: 'dabd6983-f145-472b-807d-76bc02821e8d',
    redirectUri: 'https://pipdev.nycsca.org',
    validateAuthority: true,
    postLogoutRedirectUri: 'https://pipdev.nycsca.org',
    navigateToLoginRequestUrl: true,
    cacheLocation: 'sessionStorage',
    consentScopes: ['user.read', 'api://f382cd6d-8f52-44f8-a70a-3e5d9ccd8c2e/access_as_user'],
    scopes: ['api://f382cd6d-8f52-44f8-a70a-3e5d9ccd8c2e/access_as_user'],
  }
};
